import React from "react";
import VerifyRequestForm from "user/authentication/ui/forms/VerifyRequestForm";
// Router
import * as appRouting from "appRouting";
// Bootstrap
import { Panel } from "react-bootstrap";
import AuthContainer from "user/authentication/ui/views/components/AuthContainer";
import AuthInfo from "user/authentication/ui/views/components/AuthInfo";
import AuthAlreadyHasPassword from "user/authentication/ui/views/components/AuthAlreadyHasPassword";
import AuthLinkButton from "user/authentication/ui/views/components/AuthLinkButton";
export const VerifyRequestView = () => {
    return (React.createElement(AuthContainer, { isLarge: false },
        React.createElement(Panel, null,
            React.createElement(Panel.Heading, null,
                React.createElement(Panel.Title, { componentClass: "h4" }, "Register")),
            React.createElement(Panel.Body, null,
                React.createElement(AuthInfo, null,
                    React.createElement("p", null, "We need you to verify your account in order to register with Insights."),
                    React.createElement("p", null, "A one-time pin code (OTP) will be sent to your mobile phone that you will need to complete your registration.")),
                React.createElement(VerifyRequestForm, null),
                React.createElement(AuthLinkButton, { url: appRouting.verifyPath(), text: "Already have an OTP?" }),
                React.createElement(AuthAlreadyHasPassword, null)))));
};
